"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    name: 'mainnet',
    chainId: 1,
    networkId: 1,
    defaultHardfork: 'zond',
    consensus: {
        type: 'pos',
        algorithm: 'casper',
        casper: {},
    },
    comment: 'The QRL main chain',
    url: 'https://ethstats.net/',
    genesis: {
        gasLimit: 5000,
        extraData: '0x11bbe8db4e347b4e8c937c1c8370e4b5ed33adb3db69cbdb7a38e1e50b1b82fa',
    },
    hardforks: [
        {
            name: 'zond',
            block: 0,
            forkHash: null,
        },
    ],
    bootstrapNodes: [],
    dnsNetworks: [
        'qnrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.mainnet.ethdisco.net',
    ],
};
//# sourceMappingURL=mainnet.js.map